interface Step {
  number: number;
  title: string;
}

interface ProgressStepsProps {
  steps: Step[];
  currentStep: number;
}

export default function ProgressSteps({
  steps,
  currentStep
}: ProgressStepsProps) {
  return (
    <div className="w-full mx-auto flex justify-center items-center bg-gray-100 pt-1">
      <div className="flex items-center justify-between w-full max-w-7xl">
        {steps.slice(0, 3).map((step, index) => (
          <div
            key={step.number}
            className={`flex items-center justify-center w-full ${
              step.number === currentStep ||
              (step.number === 3 && currentStep === 4)
                ? "border-b-2 border-red-500"
                : ""
            }`}
          >
            <div
              className={`relative flex max-lg:flex-col justify-center items-center gap-2 pb-1`}
            >
              {/* Circle */}
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium z-10 ${
                  step.number === currentStep ||
                  (step.number === 3 && currentStep === 4)
                    ? "bg-red-500 border-2 text-white"
                    : "bg-white border-2 border-gray-300 text-gray-500"
                }`}
              >
                {step.number}
              </div>

              {/* Title */}
              <div
                className={`text-center line-clamp-1 ${
                  step.number === currentStep ||
                  (step.number === 3 && currentStep === 4)
                    ? "text-red-500"
                    : "text-gray-500"
                }`}
              >
                {step.title}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
